import script from "./OverallView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverallView.vue?vue&type=script&lang=ts&setup=true"

import "./OverallView.vue?vue&type=style&index=0&id=489ba73a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489ba73a"]])

export default __exports__